export default __webpack_public_path__ + "static/media/img12.ddb04a45.png";